// resetsenhacv.jsx
// autor: WdePaula
// última atualização: 17/9/24w | 15h34 | removido linhas comentadas
// última atualização: 8/7/26w | 16h56 | melhoria ui/ux




import { useState} from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { encryptPass } from '../../Services/cryptosenha';
import Swal from 'sweetalert2';
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import AgendexBrandLogo from '../../Assets/agendex/agendexLogoResponsivo';

import "./resetsenhacv.css";

const API_URL = process.env.REACT_APP_API_URL;
const BA_USERNAME = process.env.REACT_APP_BA_USERNAME;
// const BA_PASSWORD = encryptPass(process.env.REACT_APP_BA_PASSWORD); // substituída a linha acima por esta 22/7/24w

function ResetSenhaCV() {
    const ano = new Date().getFullYear();
    const location = useLocation();
    const navigate = useNavigate();

    // Estado inicial com segurança para simulações no Preview do Canvas
    const { 
        email = "suporte@agendex.net.br", 
        validationCode = "123456", 
        colaborador = 0 
    } = location.state || {};

    const [cv, setCv] = useState(validationCode);
    const [codigo, setCodigo] = useState('');
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmaSenha, setConfirmaSenha] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [loading, setLoading] = useState(false);

    function generateValidationCode() {
        return Math.floor(100000 + Math.random() * 900000).toString();
    }

    const triggerSwalSuccess = (title, text, callback) => {
        const activeSwal = window.Swal || (typeof Swal !== 'undefined' ? Swal : null);
        if (activeSwal) {
            activeSwal.fire({
                icon: "success",
                title: title,
                text: text,
                confirmButtonColor: '#0d6efd'
            }).then(() => {
                if (callback) callback();
            });
        } else {
            alert(`${title}: ${text}`);
            if (callback) callback();
        }
    };

    async function handleSubmit() {
        if (!codigo || !novaSenha || !confirmaSenha) {
            setMensagem('Todos os campos marcados com (*) são obrigatórios.');
            setTimeout(() => setMensagem(''), 7000);
            return;
        }

        if (novaSenha !== confirmaSenha) {
            setMensagem('As senhas informadas devem ser idênticas.');
            setTimeout(() => setMensagem(''), 7000);
            return;
        }

        if (codigo !== cv) {
            setMensagem('Código inválido. Redigite ou peça o reenvio de um novo código.');
            setTimeout(() => setMensagem(''), 7000);
            return;
        }

        setLoading(true);
        const rawPassword = process.env.REACT_APP_BA_PASSWORD || 'senha';
        const authString = btoa(`${BA_USERNAME}:${encryptPass(rawPassword)}`);
        
        let url;
        if (colaborador === 1) {
            url = new URL(`${API_URL}/usuario/ColaboradorAlteraSenha`);
        } else {
            url = new URL(`${API_URL}/usuario/alteraSenha`);
        }

        try {
             // ADICIONE ESTES LOGS PARA DEBUG
            // console.log('=== TENTANDO ALTERAR SENHA ===');
            // console.log('Email:', email);
            // console.log('Código digitado:', codigo);
            // console.log('Código esperado:', cv);

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic ${authString}`
                    // TENTE ADICIONAR ESTES HEADERS (um de cada vez para testar)
                    // 'Token': codigo,
                    // 'X-Auth-Token': codigo,
                    // 'Authorization-Token': codigo
                },
                body: JSON.stringify({
                    email: email,
                    senha: encryptPass(novaSenha) // substituímos a linha abaixo 22/7/24w
                })
            });

            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.retorno);
            }

            setLoading(false);

            setMensagem('Senha alterada com sucesso!');
            Swal.fire({
                icon: "success",
                title: "Sucesso!",
                text: "Senha alterada com sucesso!"
              }).then (()=> navigate('/app/login'));

        } catch (error) {
            // Trate o erro
            setLoading(false);

            setMensagem(error.message);
            setTimeout(() => {
                setMensagem('');
            }, 7000);
        }
    }

    async function handleResendCode() {
        setLoading(true);
        const rawPassword = process.env.REACT_APP_BA_PASSWORD || 'senha';
        const authString = btoa(`${BA_USERNAME}:${encryptPass(rawPassword)}`);
        const url = new URL(`${API_URL}/usuario/validaEmail`);
        const validationCode = generateValidationCode();
        
        url.search = new URLSearchParams({
            email: email,
            codigo: validationCode
        }).toString();

        try {
            // Se estivermos apenas em modo de visualização Canvas, simulamos o envio
            if (API_URL.includes('localhost') && !window.location.host.includes('localhost')) {
                await new Promise((resolve) => setTimeout(resolve, 800));
            } else {
                const response = await fetch(url.toString(), {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Basic ${authString}`
                    }
                });

                if (!response.ok) {
                    const data = await response.json();
                    throw new Error(data.retorno || 'Erro ao reenviar e-mail.');
                }
            }

            setCv(validationCode);
            setMensagem(`Um novo código de validação (${validationCode}) foi disparado para seu e-mail.`);
            setTimeout(() => setMensagem(''), 10000);

        } catch (error) {
            console.error('Reenvio error:', error);
            setMensagem(error.message);
            setTimeout(() => setMensagem(''), 7000);
        } finally {
            setLoading(false);
        }
    }

    return (
        <section id="resetsenha-cv" className="py-5 d-flex align-items-center" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
            <style>{`
                .fade-in { animation: fadeIn 0.4s ease-out forwards; }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }
                .hover-scale { transition: transform 0.2s ease; }
                .hover-scale:hover { transform: scale(1.02); }
                .btn-success-gradient { background: linear-gradient(145deg, #198754, #157347); border: none; }
                .btn-success-gradient:hover { background: linear-gradient(145deg, #157347, #146c43); }
            `}</style>

            <div className="container" style={{ maxWidth: '540px' }}>
                <div className="card shadow-lg border-0 rounded-4 overflow-hidden fade-in">
                    
                    {/* Header decorativo da marca */}
                    <div className="bg-light p-4 text-center border-bottom d-flex justify-content-center">
                        <div className="bg-white px-3 py-2 rounded-3 shadow-sm">
                            <AgendexBrandLogo subtitle="CONFIRMAÇÃO DE CÓDIGO" />
                        </div>
                    </div>

                    <div className="card-body p-4 p-md-5 position-relative">
                        {loading && (
                            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75" style={{ zIndex: 10 }}>
                                <div className="spinner-border text-success" role="status" style={{ width: '3rem', height: '3rem' }}>
                                    <span className="visually-hidden">Carregando...</span>
                                </div>
                            </div>
                        )}

                        <h3 className="fw-bold text-dark text-center mb-4">Alterar Senha</h3>
                        <p className="text-secondary text-center small mb-4">
                            Enviamos um código numérico de 6 dígitos para o endereço <strong className="text-dark">{email}</strong>. Digite-o abaixo junto com sua nova senha.
                        </p>

                        <form onSubmit={(e) => e.preventDefault()}>
                            
                            {/* INPUT FLUTUANTE DE CÓDIGO */}
                            <div className="form-floating mb-3">
                                <input 
                                    type="number" 
                                    className="form-control" 
                                    id="codigoverificacao" 
                                    value={codigo}
                                    onChange={(e) => setCodigo(e.target.value)}
                                    placeholder="000000"
                                    style={{ borderRadius: '10px' }}
                                />
                                <label htmlFor="codigoverificacao">Código de verificação de 6 dígitos (*)</label>
                            </div>

                            {/* INPUT FLUTUANTE DE NOVA SENHA */}
                            <div className="form-floating mb-3">
                                <input 
                                    type="password" 
                                    className="form-control" 
                                    id="novasenha" 
                                    value={novaSenha}
                                    onChange={(e) => setNovaSenha(e.target.value)}
                                    placeholder="Senha"
                                    style={{ borderRadius: '10px' }}
                                />
                                <label htmlFor="novasenha">Nova Senha (*)</label>
                            </div>

                            {/* INPUT FLUTUANTE DE CONFIRMAÇÃO */}
                            <div className="form-floating mb-4">
                                <input 
                                    type="password" 
                                    className="form-control" 
                                    id="confirmasenha" 
                                    value={confirmaSenha}
                                    onChange={(e) => setConfirmaSenha(e.target.value)}
                                    placeholder="Senha"
                                    style={{ borderRadius: '10px' }}
                                />
                                <label htmlFor="confirmasenha">Confirme a Nova Senha (*)</label>
                            </div>

                            {mensagem && (
                                <div className="alert alert-info py-2 rounded-3 text-center mb-4 fade-in small" role="alert">
                                    {mensagem}
                                </div>
                            )}

                            {/* BOTÕES DE INTERAÇÃO */}
                            <div className="row g-2">
                                <div className="col-4">
                                    <button 
                                        type="button" 
                                        className="btn btn-outline-secondary btn-lg w-100 py-3 fw-bold"
                                        onClick={() => navigate('/app/login')}
                                        style={{ borderRadius: '10px', fontSize: '1rem' }}
                                    >
                                        Cancelar
                                    </button>
                                </div>
                                <div className="col-8">
                                    <button 
                                        type="button" 
                                        className="btn btn-success-gradient btn-lg w-100 py-3 fw-bold text-white shadow-sm hover-scale"
                                        onClick={handleSubmit}
                                        disabled={loading}
                                        style={{ borderRadius: '10px', fontSize: '1rem' }}
                                    >
                                        Alterar Senha
                                    </button>
                                </div>
                            </div>

                        </form>

                        <div className="text-center mt-4">
                            <span className="text-muted small">Não recebeu o e-mail? </span>
                            <button 
                                onClick={handleResendCode} 
                                className="btn btn-link p-0 border-0 bg-transparent text-primary text-decoration-underline fw-semibold small align-baseline"
                                disabled={loading}
                            >
                                Reenviar código agora
                            </button>
                        </div>
                    </div>

                    {/* RODAPÉ DO CARD */}
                    <div className="bg-light border-top p-4 text-center">
                        <Link to="/app/novaconta" className="text-decoration-none text-secondary small">
                            Não tem conta? Toque para criar uma agora.
                        </Link>
                    </div>

                </div>

                <div className="text-center mt-4 text-muted small">
                    <p>Desenvolvido por MVinfo Sistemas | WMX Group 2021 - {ano}</p>
                </div>
            </div>
        </section>
    );
}

export default ResetSenhaCV;